import { Theme } from '@mui/material';

export const getContainerStyles = (theme: Theme, fullWidth?: boolean) => ({
	maxWidth: '120rem',
	width: '100%',
	[theme.breakpoints.up('lg')]: {
		paddingLeft: fullWidth ? '0' : '5%',
		paddingRight: fullWidth ? '0' : '5%',
	},
	[theme.breakpoints.between('md', 'lg')]: {
		paddingLeft: fullWidth ? '0' : '2%',
		paddingRight: fullWidth ? '0' : '2%',
	},
	[theme.breakpoints.down('md')]: {
		paddingLeft: '0',
		paddingRight: '0',
	},
});

export const getMapAndLocationsComponentStyles = (
	theme: Theme,
	fullWidth?: boolean,
	isLocationCardsInHeader?: boolean
) => ({
	display: 'flex',
	height: 'calc(100vh - 12.5rem)',
	borderRadius: fullWidth ? '0' : '0.5rem',
	marginBottom: fullWidth ? '0' : '1.25rem',
	justifyContent: 'flex-start',
	[theme.breakpoints.down('md')]: {
		height: 'auto',
	},
	...(isLocationCardsInHeader && { height: '100%' }),
	flexWrap: 'nowrap'
});
